<div class="customStepper">
	<div class="row">
		<div class="col-md-4">
			<div class="input-group">
				<input
					type="text"
					name="search"
					[formControl]="searchText"
					(ngModelChange)="searchKey($event)"
					class="form-control"
					placeholder="{{ page?.searchUser }}"
				/>
				<img
					src="../../../../../assets/img/search-icon.svg"
					class="search-icon"
					alt="search"
				/>
			</div>
		</div>
	</div>
	<div
		class="d-flex justify-content-between align-items-center pt-3 py-2 w-100"
	>
		<p>{{ page?.selectUsers }}</p>
		<label class="container-chk">
			<a class="link-purple">{{ page?.selectAll }}</a>
			<input
				type="checkbox"
				[(ngModel)]="masterSelected"
				name="list_name"
				value="m1"
				(change)="checkUncheckAll()"
			/>
			<span class="checkmark"></span>
		</label>
	</div>

	<div class="userGroups mb-3">
		<div class="row">
			<div
				class="col-md-6 pl-4  {{ i % 2 == 0 ? 'divider-rgt' : '' }}"
				*ngFor="let member of members; let i = index"
			>
				<label class="container-chk">
					{{ member.name }}
					<p class="mb-0">{{ member.email }}</p>
					<input
						type="checkbox"
						[(ngModel)]="member.checked"
						name="list_name"
						value="{{ member.id }}"
						(change)="isAllSelected()"
					/>
					<span class="checkmark"></span>
				</label>
			</div>
			<ng-container *ngIf="members.length == 0">
				{{ page?.noRecord }}
			</ng-container>
		</div>
	</div>
</div>
<div
	class="d-flex justify-content-center align-items-center border-top pt-3 btn-row-c"
>
	<div class="d-flex mr-3">
		<button
			cdkStepperPrevious
			type="button"
			(click)="clearLocalVaule()"
			class="btn btn-ex-small btn-outline btn-outline-purple mx-1"
		>
			<i class="fas fa-chevron-left"></i>
		</button>
		<button
			cdkStepperNext
			type="button"
			(click)="stepTwoSubmit()"
			class="btn btn-ex-small btn-outline btn-outline-purple mx-2"
		>
			<i class="fas fa-chevron-right"></i>
		</button>
	</div>
</div>
